export default __webpack_public_path__ + "static/media/airvendlogo 1.e099c795.svg";